// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"690b4917","498":"ef2bd5d1","703":"06b49c75","787":"5996c6d3"}[chunkId] + ".chunk.js";
};